export default __webpack_public_path__ + "static/media/coin_5gms.3132aeed.jpg";